// extracted by mini-css-extract-plugin
export default {"popper":"FilterAmenities_popper__ZiYlq"};